var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 17.945,
    viewBox: "0 0 22 17.945",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail",
    transform: "translate(-1.15 -3.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2700",
    "data-name": "Group 2700",
    transform: "translate(1.15 3.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2032",
    "data-name": "Path 2032",
    d: "M4.039,3.15H20.26A2.893,2.893,0,0,1,23.15,6.039V18.205a2.893,2.893,0,0,1-2.889,2.889H4.039A2.893,2.893,0,0,1,1.15,18.205V6.039A2.893,2.893,0,0,1,4.039,3.15ZM20.26,19.371a1.167,1.167,0,0,0,1.166-1.166V6.039A1.167,1.167,0,0,0,20.26,4.873H4.039A1.167,1.167,0,0,0,2.873,6.039V18.205a1.167,1.167,0,0,0,1.166,1.166Z",
    transform: "translate(-1.15 -3.15)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2033",
    "data-name": "Path 2033",
    d: "M12.15,13.85a.869.869,0,0,1-.494-.154L1.518,6.7a.843.843,0,0,1-.212-1.184.869.869,0,0,1,1.2-.209l9.644,6.659L21.794,5.3a.869.869,0,0,1,1.2.209A.843.843,0,0,1,22.782,6.7l-10.138,7A.869.869,0,0,1,12.15,13.85Z",
    transform: "translate(-1.15 -3.15)",
    fill: "#212121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.e08617877cd18a82f2fe4a4b2e1d5376.svg";
export { ForwardRef as ReactComponent };